import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import { BillingProvider } from "./contexts/BillingContext";
import "./wireframe.generated.css";
import "./index.css";

const container = document.getElementById("root");
if (!container) throw new Error("No se encontró el elemento root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <BillingProvider>
          <App />
        </BillingProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
